import React from 'react'
import { useIntl } from 'react-intl'
import { Text, Link } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'

export const freeTrailTermsAndConditionsLink =
  'https://www.contrastsecurity.com/terms-and-conditions-ft'
export const freeTrailPrivacyPolicyUrl =
  'https://www.contrastsecurity.com/privacy-matters'

const FreeTrialTermsLink = ({ msg, url }) => {
  return (
    <Link href={url} isExternal={true}>
      {msg}
    </Link>
  )
}

const termsTextCss = css`
  font-size: 14px;
  margin: 0;
`

export const FreeTrialTermsText = () => {
  const { formatMessage } = useIntl()

  return (
    <Text font="body" className={termsTextCss}>
      {formatMessage(
        {
          id: 'variable_changePassword_agreeTermsAndConditions_react'
        },
        {
          a1: (...msg) => (
            <FreeTrialTermsLink
              msg={msg}
              url={freeTrailTermsAndConditionsLink}
            />
          ),
          a2: (...msg) => (
            <FreeTrialTermsLink msg={msg} url={freeTrailPrivacyPolicyUrl} />
          )
        }
      )}
    </Text>
  )
}
